import * as React from 'react';

export interface Props extends React.Props<Panel> {
	title:string

	/** The icon shown to the left of the title in the title bar. */
	iconPath?:string;

	/** Icon shown in the right hand side of the panel title, might be a close, or delete icon for example. */
	rightIconPath?:string;
	rightIconClick?:() => void;
}

/**
 * A panel has a heading and a body. The heading is displayed in Glossy Bar with beautiful orange, or purple
 * in purple bar. The body will be whatever the children of this component are.
 * In addiition to a title, you can also have an icon show in the left corner by specifying the 'iconPath'
 * property. If you require, there is also an icon to dipslay in the right, via 'rightIconPath'. This handles
 * click events via the 'rightIconClick' property (e.g. for closing the panel with an 'x' icon).
 */
export class Panel extends React.Component<Props, {}> {
	render() {
		return <div className="sbPanel sbRoundedEdges react">
			<div className="sbPanelTitlebar sbRoundedEdges">
				{this.renderLeftIcon()}
				{this.props.title}
				{this.renderRightIcon()}
			</div>
			<div className="sbPanelContents">
				{this.props.children}
			</div>
		</div>
	}

	renderLeftIcon() {
		if (this.props.iconPath == null) {
			return null;
		}

		return <span className="icon">
			<img src={this.props.iconPath} />
		</span>
	}

	renderRightIcon() {
		if (this.props.rightIconPath == null) {
			return null;
		}

		const img   = <img src={this.props.rightIconPath} />;
		const rightIconClick = this.props.rightIconClick
		const inner = rightIconClick == null ? img :
			<a href="#" onClick={(event) => { rightIconClick(); event.preventDefault() }}>{img}</a>;

		return <span className="right-icon">{inner}</span>;
	}
}



// WEBPACK FOOTER //
// ./src/lib/sbhtml/panel.tsx